import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { SLIDE_UP_ANIMATION } from '../../../animations/slide-up.animation';
import {GoBackButtonService} from '../../../services/go-back-button.service';
import {AlternativeDatatablesComponent} from '../../../shared/alternative-datatables/alternative-datatables.component';
import {AlternativeDatatablesInterface} from '../../../shared/alternative-datatables/alternative-datatables.interface';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Subject, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {JsonClientService} from '../../../shared/json-client';
import {NotificationService} from '../../../services/notification.service';
import {debounceTime} from 'rxjs/operators';
import {TemplateService} from '../../../services/template.service';


@Component({
    selector: 'app-condition-developer-list',
    templateUrl: './condition-developer-list.component.html',
    styleUrls: [
        './condition-developer-list.component.scss',
    ],
    animations: [SLIDE_UP_ANIMATION],
    standalone: false
})
export class ConditionDeveloperListComponent
  extends AlternativeDatatablesComponent
  implements AlternativeDatatablesInterface, OnInit, OnDestroy, AfterViewInit {

  public head;
  public summary;

  public filterColumns = {};
  public form: UntypedFormGroup;
  public filter: string;

  private parasites = true;

  public filterSubject: Subject<void> = new Subject<void>();
  private filterSubscription: Subscription;
  private formSubscription: Subscription;

  public currentPage = 1;

  public count;
  public rows;

  public sort: { [key: string]: string } = {};


  public set data(value) {
    this.count = value['count'];
    this.rows = value['rows'];
  }

  public set searchValue(value: any) {
    this.filter = value;
    this.onFilterChanges(this.filter);
  }

  public get searchValue(): any {
    return this.filter;
  }


  constructor(public http: JsonClientService,
              private notify: NotificationService,
              public goBack: GoBackButtonService,
              private router: Router,
              private fb: UntypedFormBuilder,
              public activatedRoute: ActivatedRoute,
              private template: TemplateService,
              private cdr: ChangeDetectorRef) {
    super(router, activatedRoute, fb, http);

    this.filterSubscription = this.filterSubject
      .pipe(debounceTime(500))
      .subscribe(_ => this.onFilterChanges());
  }

  bSet() {
    this.goBack.header = '<h2>Условия реализации и КВ</h2>';
    this.template.setHeader('Условия реализации и КВ');
  }

  ngOnInit() {
    this.form = this.fb.group({});
    this.head = [
      {'name': 'developer_caption', 'value': '', 'caption': 'Застройщик', 'sort': false, 'input': true},
      {'name': 'developer_conditions_text', 'value': '', 'caption': 'УВ', 'sort': false, 'input': false},
      {'name': 'developer_date_to', 'value': '', 'caption': 'Дата до', 'sort': false, 'input': false},
      {'name': 'developer_author', 'value': '', 'caption': 'Изменено, Автор', 'sort': false, 'input': false},
      {'name': 'complex_caption', 'value': '', 'caption': 'ЖК', 'sort': false, 'input': false},
      {'name': 'complex_proc_spn', 'value': '', 'caption': 'КВ Аг', 'sort': false, 'input': false},
      {'name': 'complex_proc', 'value': '', 'caption': 'КВ СА', 'sort': false, 'input': false},
      {'name': 'complex_date_to', 'value': '', 'caption': 'Дата до', 'sort': false, 'input': false},
      {'name': 'complex_author', 'value': '', 'caption': 'Изменено, Автор', 'sort': false, 'input': false},
      {'name': 'xml', 'value': '', 'caption': 'xml', 'sort': false, 'input': false, 'width': '17px'},
      // {'name': 'cond', 'value': '', 'caption': 'Условия', 'sort': false, 'input': false},
    ];

    this.head = this.head.map(x => {
      x.value = this.activatedRoute.snapshot.queryParams[x.name] || x.value;
      return x;
    });
    if (this.activatedRoute.snapshot.queryParams['sort_name']) {
      this.sort[this.activatedRoute.snapshot.queryParams['sort_name']] = this.activatedRoute.snapshot.queryParams['sort_key'];
    }

    this.formSubscription = this.form.valueChanges
      .subscribe(_ => this.filterSubject.next());

    for (const el of this.head) {
      this.form.addControl(el.name, new UntypedFormControl(el.value));
    }

    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.onInitCall();
    this.summary = this.activatedRoute.snapshot.data['summary'];
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  onFilterChanged(): void {
    this.filter = this.activatedRoute.snapshot.queryParams['global_search_string'] || '';
    this.data = this.activatedRoute.snapshot.data['data'];
    this.currentPage = +this.activatedRoute.snapshot.queryParams['page'] || 1;
    this.bSet();
  }

  onFilterChanges(text = null) {
    if (text !== null) {
      this.filter = text;
    }

    this.filterColumns = {};
    const cols = [...this.head];
    for (const el of cols) {
      if (!this.form.get(el.name).value.length) {
        continue;
      }
      this.filterColumns[el.name] = this.form.get(el.name).value;
    }
    if (this.filter !== '') {
      this.filterColumns['global_search_string'] = this.filter;
    }
    if (this.sort) {
      this.filterColumns['sort_name'] = Object.keys(this.sort)[0];
      this.filterColumns['sort_key'] = this.sort[this.filterColumns['sort_name']];
    }
    if (this.parasites) {
      return this.parasites = !this.parasites;
    }
    this.router.navigate(['condition'], {
      queryParams: this.getQueryParams(),
    });
  }

  getQueryParams() {
    const query_params = {}, cols = [...this.head];
    for (const el of cols) {
      let _val = this.form.get(el.name).value;
      if (!_val.length) {
        continue;
      }
      if (_val === 'true' || _val === 'false') {
        _val = _val === 'true';
      }
      query_params[el.name] = _val;
    }
    if (this.sort) {
      query_params['sort_name'] = Object.keys(this.sort)[0];
      query_params['sort_key'] = this.sort[query_params['sort_name']];
    }
    if (this.filter !== '') {
      query_params['global_search_string'] = this.filter;
    }
    return query_params;
  }

  prepareSort(column_name: string) {
    for (const key in this.sort) {
      if (column_name !== key) {
        delete this.sort[key];
      }
    }
  }

  sortChange(column_name: string) {
    this.prepareSort(column_name);
    this.sort[column_name] = !this.sort[column_name] || ('desc' === this.sort[column_name]) ? 'asc' : 'desc';
    this.onFilterChanges();
  }

  ngAfterViewInit() {
    // this.bSet();
    // this.goBack.goScroll();
    // this.cdr.detectChanges();
  }
}
